import type { Testimonial } from '../types/offer'

export const featuredTestimonial: Testimonial = {
  name: 'Rahman K.',
  location: 'Dhaka',
  role: 'Freelancer (+$8,000/month)',
  quote:
    'I went from struggling with self-doubt to landing international clients paying me 5x more. The Argentine Mindset rewired how I see challenges. Best investment ever.',
  avatar:
    'https://cdn.magicpatterns.com/patterns/generated-images/80dc2206-71b8-4a00-939a-78bcdb037bdd.jpg',
}

export const testimonials: Testimonial[] = [
  {
    name: 'Fatima R.',
    location: 'Chittagong',
    role: 'Business Owner',
    quote:
      'As a woman entrepreneur in Chittagong, I was always the cheapest option. After implementing these strategies, I now lead my market. This book changed EVERYTHING.',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/b68498bb-922a-4d80-aca2-bbb9c2ae262e.jpg',
  },
  {
    name: 'Sohail H.',
    location: 'Sylhet',
    role: 'Sales Professional',
    quote:
      'The penalty mindset section alone is worth 10x the price. I use it before every important negotiation. My income doubled in 6 months.',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/f1d60429-a7bc-4cba-a6a4-7ffa06c158ee.jpg',
  },
  {
    name: 'Asha D.',
    location: 'Dhaka',
    role: 'Student (now freelancing $2,500/month)',
    quote:
      "I recommend this to every ambitious person I know. It's not just about mindset, it's about building an unstoppable system. Thank you.",
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/57bfb06f-f38c-44d3-8c93-841785695808.jpg',
  },
]
